import React, { useState } from 'react';
import { getTransactionsByDateAPI } from './StudentAPI';

const DownloadTransactionsModal = ({ showModal, onClose }) => {
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const handleDownload = async () => {
        if (!startDate || !endDate) {
            setError('Please select both a start and end date.');
            return;
        }
        setError('');
        setLoading(true);

        const transactions = await getTransactionsByDateAPI(startDate, endDate);
        setLoading(false);

        if (!transactions) {
            setError('Failed to fetch transactions. Please try again.');
            return;
        }

        const header = 'transaction_id,date,student_name,amount,teacher_name';
        const rows = transactions.map(t =>
            [
                t.transaction_id,
                t.transaction_date.split('T')[0],
                `"${t.student_name}"`,
                t.amount,
                `"${t.teacher_name}"`,
            ].join(',')
        );
        const csv = [header, ...rows].join('\n');

        const blob = new Blob([csv], { type: 'text/csv' });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `transactions_${startDate}_${endDate}.csv`;
        a.click();
        URL.revokeObjectURL(url);
    };

    if (!showModal) {
        return null;
    }

    return (
        <div className="modal show" tabIndex="-1" style={{ display: 'block' }}>
            <div className="modal-dialog">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Download Transactions</h5>
                        <button type="button" className="close" onClick={onClose}>
                            <span>&times;</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        <div className="form-group">
                            <label>Start Date:</label>
                            <input
                                type="date"
                                className="form-control"
                                value={startDate}
                                onChange={e => setStartDate(e.target.value)}
                            />
                        </div>
                        <div className="form-group mt-2">
                            <label>End Date:</label>
                            <input
                                type="date"
                                className="form-control"
                                value={endDate}
                                onChange={e => setEndDate(e.target.value)}
                            />
                        </div>
                        {error && <div className="text-danger mt-2">{error}</div>}
                    </div>
                    <div className="modal-footer">
                        <button
                            type="button"
                            className="btn btn-primary"
                            onClick={handleDownload}
                            disabled={loading}
                        >
                            {loading ? 'Downloading...' : 'Download CSV'}
                        </button>
                        <button
                            type="button"
                            className="btn btn-secondary"
                            onClick={onClose}
                        >
                            Close
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DownloadTransactionsModal;
